<template>
  <div
    class="mt-20 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2"
  >
    <div
      class="w-services-item max-w-full md:order-2 sm:order-1"
    >
      <h3 class="text-lg font-regular-bold mb-4">{{ title }}</h3>
      <p class=" font-light">
        <slot />
      </p>
    </div>
    <div class="md:order-1 sm:order-2 px-32 max-h-full max-w-full">
      <img :src="require('@/assets/images/' + title + '.svg')" :alt="title" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail-odd',
  props: ['title'],
};
</script>
